// ensure-unit-saved.utils.ts
import { AppDispatch } from "@/core/root-reducer"
import unitStore from "@/features/risks/entities/unit/model/unit.store"
import { Unit } from "@/features/risks/entities/unit/model/unit.types"
import { toast } from "react-toastify"
import { t } from "i18next"

/**
 * Sauvegarde l'unité si nécessaire et retourne une instance persistée.
 * - Si une unité avec le même nom existe déjà, la retourne (sans créer de doublon).
 * - Si le draft est non vide, tente de la sauvegarder.
 * - Sinon retourne null.
 */
export async function ensureUnitSaved(
  unit: Unit | null,
  unitDraft: Unit,
  units: Unit[],
  dispatch: AppDispatch
): Promise<Unit | null> {
  // Cas 1 : une unité avec le même nom existe déjà en base
  const existingUnit = units.find((u) => u.name === unitDraft.name.trim())
  if (existingUnit) {
    toast(t("Une unité avec ce nom existe déjà"), { type: "info" })
    return existingUnit
  }

  // Cas 2 : draft non vide
  if (unitDraft.name.trim() !== "") {
    try {
      const saved = await dispatch(unitStore.thunks.createEntity(unitDraft)).unwrap()
      dispatch(unitStore.actions.setActive(saved))
      dispatch(unitStore.actions.addMany([saved]))
      return saved
    } catch (err) {
      console.error("❌ Save unit failed", err)
      return null
    }
  }

  return null
}
